import { Column } from "@bunnix/components";
import { useEffect, useMemo, useState } from "@bunnix/core";
import { useStore } from "./store/store.mjs";
import AppHeaderBar from "./app-header-bar.mjs";
import NewsPage from "./news-page.mjs";
import { readLastSelection } from "./store/persistence.mjs";
import "./app.css";

export default function App() {
  const { store, persistSelection, updateTopic } = useStore();

  const restored = readLastSelection(store.get().userPreferences);
  const topic = useState(restored.kind === "topic" ? restored.id : "headlines");
  const news = useMemo([store, topic], (s, t) =>
    t ? (s.newsByTopic[t] ?? []) : [],
  );

  useEffect((t) => {
    updateTopic({ topic: t });
    persistSelection("topic", t);
  }, topic);

  useEffect((s) => {
    console.log(s);
  }, store);

  return Column(
    { class: "app", gap: 0 },
    AppHeaderBar({ selectedTopic: topic }),

    Column(
      {
        overflowY: "scroll",
        safeInsets: "horizontal"
      },
      Column(
        {
          width: `min(1024px, 100%)`,
          paddingY: "regular",
          paddingX: 24,
          marginX: "auto",
        },
        NewsPage({ topic, news }),
      ),
    ),
  );
}
